import Transformer from "./../transformer";
import { shortDate } from "./../../filters";

const residentTransformer = ({ id, user: { receive_name: name } }) => {
  return {
    id,
    name,
  };
};
const providerTransformer = ({
  id,
  name,
  commercial_name: commercialName,
  provider_number: providerNumber,
}) => {
  return {
    id,
    name,
    commercialName,
    providerNumber,
  };
};
const supplyTransformer = ({
  id,
  buy_order: buyOrder,
  buy_order_price: buyOrderPrice,
  freight_cost: freightCost,
  quantity,
  status,
  total_price: total,
  unit_price: unitPrice,
  supply: {
    supply_name: name,
    supply_unit_measurement: unitMeasurement,
    id: supplyId,
  },
  warehouse_movement_detail_history: {
    total_entries: totalEntries,
    quantity_physical: quantityPhysical,
  },
}) => {
  return {
    id,
    buyOrder,
    buyOrderPrice,
    freightCost,
    quantity: +quantity,
    name,
    total: +total,
    unitPrice: +unitPrice,
    unitMeasurement,
    totalEntries: +totalEntries,
    quantityPhysical: +quantityPhysical,
    realReceivedAmount: 0,
    receivedQuantity: 0,
    supplyId,
    status,
  };
};

class PurchaseOrderTransformer extends Transformer {
  static fetch({
    add_date: addDate,
    does_VAT_apply: doesVATApply,
    expected_delivery_date: expectedDeliveryDate,
    expectedDeliveryDays: expectedDeliveryDays,
    file,
    folio,
    full_entries_in_crol: fullEntriesInCrol,
    has_material_entries: hasMaterialEntries,
    has_material_entries_task: hasMaterialEntriesTask,
    highway,
    id,
    is_active: isActive,
    is_updated: isUpdated,
    iva,
    payment_conditions: paymentConditions,
    provider,
    provider_comments: providerComments,
    resident,
    resident_validation: residentValidation,
    send_conditions: sendConditions,
    status,
    subtotal,
    supplies_consolidated: suppliesConsolidated,
    total,
    transfer_code: transferCode,
    validation_date: validationDate,
  }) {
    return {
      addDate: shortDate(addDate),
      doesVATApply,
      expectedDeliveryDate,
      expectedDeliveryDays,
      file,
      folio,
      fullEntriesInCrol,
      hasMaterialEntries,
      hasMaterialEntriesTask,
      highway,
      id,
      isActive,
      isUpdated,
      iva,
      paymentConditions,
      provider: provider ? providerTransformer(provider) : {},
      providerComments,
      resident: resident ? residentTransformer(resident) : {},
      residentValidation,
      sendConditions,
      status,
      subtotal: +subtotal,
      suppliesConsolidated: suppliesConsolidated
        ? suppliesConsolidated.map((supply) => supplyTransformer(supply))
        : [],
      total: +total,
      transferCode,
      validationDate,
    };
  }
}

export default PurchaseOrderTransformer;



// WEBPACK FOOTER //
// ./src/transformers/purchase/purchaseOrder.js